module.exports = __webpack_public_path__ + "img/icn_website.908bd02d.svg";